import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../compoment/PortraitStage";

interface IdleScreenTimeModalProps extends ModalProps {
  onHide: () => void;
  onContinue: () => void;
  onQuit: () => void;
}

const IdleScreenTimeModal = ({
  onHide,
  onContinue,
  onQuit,
  ...props
}: IdleScreenTimeModalProps) => {
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      onHide={onHide}
      backdrop="static"
      className="idleModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        {/* <button type="button" className="btnCloseIdleModal" onClick={onQuit}>
          <svg width="32" height="32" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="8" fill="#DFDFDF" />
            <path d="M31 19L19 31" stroke="#33363F" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M19 19L31 31" stroke="#33363F" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
          </svg>
        </button> */}
        <div className="otpModalBody mt-2">
          <div className="header">
            Are you still there?
          </div>
          <div className="description">
            Your session is about to expire due to inactivity. Continue now to keep creating.
          </div>

          <div className="d-flex gap-3 mx-5">
            <button type="button" className="btnOutline w-100" onClick={onQuit}>
              Quit
            </button>
            <button type="button" className="btnPrimary w-100" onClick={onContinue}>
              Continue
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IdleScreenTimeModal;
